/* SG-MOBILE-TABBAR v2 (2026-10-01): bottom tab bar + full-screen search for phones (max-width 749px), and the
   Captain Gus dock (minimized signup popup) at every width.
   Markup: snippets/sg-mobile-tabbar.liquid. Styles: assets/sg-mobile-tabbar.css.
   Search reuses the header's existing search: the overlay borrows the header's .header-search node (form,
   #HeaderSearchInput, #SearchSuggestions, predictive search already bound in layout/theme.liquid) and puts it back on close.
   Menu clicks the existing .mobile-menu-toggle (opens #MobileDrawer). Cart is a plain data-cart-trigger link (theme.liquid
   opens the cart drawer; its data-cart-count badge is kept live by window.updateCartCount). */
(function () {
  'use strict';
  if (window.__sgmnInit) return; window.__sgmnInit = true;

  var mq = window.matchMedia('(max-width: 749px)');
  var root = document.documentElement;
  var overlay = document.getElementById('SgmnSearch');
  var slot = overlay && overlay.querySelector('[data-sgmn-slot]');
  var hs = document.querySelector('header .header-search');
  var home = null, homeNext = null, opener = null, isOpen = false;

  function setExpanded(v) {
    document.querySelectorAll('[data-sgmn-search]').forEach(function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); });
  }
  function focusables() {
    return Array.prototype.filter.call(
      overlay.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }

  function openSearch(src) {
    if (!overlay || !slot || !hs) { window.location.href = '/search'; return; }
    if (isOpen) return;
    isOpen = true;
    opener = src || document.activeElement;
    home = hs.parentNode; homeNext = hs.nextSibling;
    slot.appendChild(hs);
    overlay.hidden = false;
    root.classList.add('sgmn-search-open');
    setExpanded(true);
    // focus synchronously inside the tap handler so iOS raises the keyboard
    var input = hs.querySelector('input[name="q"]');
    if (input) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
    window.requestAnimationFrame(function () { overlay.classList.add('is-open'); });
  }

  function closeSearch(restoreFocus) {
    if (!isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    var box = hs.querySelector('.search-suggestions');
    if (box) { box.hidden = true; box.innerHTML = ''; }
    if (home) home.insertBefore(hs, (homeNext && homeNext.parentNode === home) ? homeNext : null);
    root.classList.remove('sgmn-search-open');
    setExpanded(false);
    if (restoreFocus !== false && opener && typeof opener.focus === 'function' && opener.isConnected) {
      suppressCardFocus = true;
      try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); }
      suppressCardFocus = false;
    }
  }
  window.SGMobileSearch = { open: openSearch, close: closeSearch };

  // bottom bar: Search
  document.querySelectorAll('[data-sgmn-search]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openSearch(btn); });
  });
  // overlay: Close, Escape, focus trap
  if (overlay) {
    overlay.querySelectorAll('[data-sgmn-search-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); closeSearch(); });
    });
    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { closeSearch(); return; }
      if (e.key !== 'Tab') return;
      var t = focusables(); if (!t.length) return;
      var first = t[0], last = t[t.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  // homepage search card: a tap opens the same full-screen search (the card stays a plain GET form without JS)
  var suppressCardFocus = false;
  if (overlay && slot && hs) {
    document.querySelectorAll('[data-sgmn-card]').forEach(function (form) {
      var input = form.querySelector('[data-sgmn-card-input]');
      var pointer = false;
      form.addEventListener('submit', function (e) { if (mq.matches) { e.preventDefault(); openSearch(input); } });
      if (!input) return;
      input.readOnly = true;
      input.addEventListener('pointerdown', function () { pointer = true; });
      input.addEventListener('click', function (e) { e.preventDefault(); pointer = false; openSearch(input); });
      input.addEventListener('focus', function () {   // keyboard users tabbing in
        if (pointer || suppressCardFocus) return;
        openSearch(input);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openSearch(input); }
      });
    });
  }

  // bottom bar: Menu -> the existing mobile drawer
  document.querySelectorAll('[data-sgmn-menu]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      closeSearch(false);
      var toggle = document.querySelector('.mobile-menu-toggle');
      if (toggle) toggle.click(); else window.location.href = '/pages/shop-by-category';
    });
  });

  // leaving phone width or coming back from bfcache: hand the header search back
  function onMq() { if (!mq.matches) closeSearch(false); }
  if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
  window.addEventListener('pageshow', function (e) { if (e.persisted) closeSearch(false); });
})();

/* ---- Captain Gus dock: the signup popup's minimized state (all widths) ----
   The popup snippet (snippets/sg-signup-popup.liquid, unedited) hides its pill and stores 'dismissed:<ts>' (14 days) when the
   pill X or the open popup is closed. Instead of Gus vanishing, he docks at the left edge (peek + "!" bubble) and stays docked
   on later pages for that window. Tap -> window.SGSignup.open(). Never shown to subscribers, when the popup isn't rendered,
   on cart/checkout/account pages, or with ?sgcap=off (html.sg-cap5 off). */
(function () {
  'use strict';
  var dock = document.getElementById('SgmnGusDock');
  var root = document.getElementById('sgp'), pill = document.getElementById('sgp-pill');
  if (!dock || !root || !pill) return;
  var html = document.documentElement, KEY = 'sg_signup_v1';
  var blocked = /^\/(cart|checkout|checkouts|account|challenge|password)(\/|$)/.test(location.pathname);
  function stored() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
  function minimized() { var m = /^dismissed:(\d+)$/.exec(stored()); return !!(m && Date.now() < +m[1]); }

  // Gus artwork: clone the popup pill's own Gus (unique clip-path id so it never resolves to a hidden copy)
  var fig = dock.querySelector('[data-sgmn-dock-fig]'), src = pill.querySelector('.sgp-gus__svg');
  if (fig && src && !fig.firstChild) {
    var svg = src.cloneNode(true);
    var cp = svg.querySelector('clipPath[id]');
    if (cp) {
      var oldId = cp.id, newId = 'sgmn-' + oldId;
      cp.id = newId;
      [].forEach.call(svg.querySelectorAll('[clip-path]'), function (n) { n.setAttribute('clip-path', n.getAttribute('clip-path').replace('#' + oldId, '#' + newId)); });
    }
    fig.appendChild(svg);
  }

  function show() {
    if (blocked || !html.classList.contains('sg-cap5') || stored() === 'subscribed') return;
    if (!pill.hidden || root.classList.contains('is-open') || !dock.hidden) return;
    dock.hidden = false;
    dock.classList.remove('is-in'); void dock.offsetWidth; dock.classList.add('is-in');
  }
  function hide() { dock.hidden = true; dock.classList.remove('is-in'); }
  window.SGGusDock = { show: show, hide: hide };

  dock.addEventListener('click', function (e) {
    e.preventDefault(); hide();
    if (window.SGSignup && typeof window.SGSignup.open === 'function') window.SGSignup.open();
  });
  // minimized from the pill X
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-sgp-gus-x], [data-sgp-pill-x]')) setTimeout(show, 220);
  });
  // minimized from the open popup (X, backdrop, Escape)
  var wasOpen = root.classList.contains('is-open');
  new MutationObserver(function () {
    var isOpen = root.classList.contains('is-open');
    if (isOpen) hide(); else if (wasOpen) setTimeout(show, 300);
    wasOpen = isOpen;
  }).observe(root, { attributes: true, attributeFilter: ['class'] });
  // the full pill (first visit) takes over from the dock
  new MutationObserver(function () { if (!pill.hidden) hide(); }).observe(pill, { attributes: true, attributeFilter: ['hidden'] });
  document.addEventListener('sg:signup', hide);
  // already minimized on an earlier page
  if (minimized()) setTimeout(show, 900);
})();
